"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
exports.defaultConfig = {
    checks: [],
    events: {
        onStepFinish: function () { return ({}); },
        onTestingFinish: function () { return ({}); },
        onStatusUpdate: function () { return ({}); },
        onTestFail: function () { return ({}); },
    },
};
